/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "tzkG");
/******/ })
/************************************************************************/
/******/ ({

/***/ "6dB8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C7vi":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "ECJt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F+rK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("Lt47");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/src/components/form/style.css
var style = __webpack_require__("qNvi");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/src/components/form/form_row_style.css
var form_row_style = __webpack_require__("Lq60");
var form_row_style_default = /*#__PURE__*/__webpack_require__.n(form_row_style);

// EXTERNAL MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/node_modules/classnames/index.js
var classnames = __webpack_require__("C7vi");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/src/components/form/form_field_style.css
var form_field_style = __webpack_require__("ECJt");
var form_field_style_default = /*#__PURE__*/__webpack_require__.n(form_field_style);

// CONCATENATED MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/src/components/form/form_field.js


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var cx = classnames_default.a.bind(form_field_style_default.a);

var form_field_FormField = function (_Component) {
	_inherits(FormField, _Component);

	function FormField() {
		var _temp, _this, _ret;

		_classCallCheck(this, FormField);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (newValue) {
			_this.props.validateAndStoreField(_this.props.field.mapping, newValue);
		}, _this.renderField = function (field, responses) {
			return _this.props.fieldTypeRenderer.renderField(_this.updateValue.bind(_this), field, responses);
		}, _this.renderValidationMessages = function (field, responses) {
			if (responses[field.mapping].validationErrors.length === 0) return null;
			var validationMessage = responses[field.mapping].validationErrors.reduce(function (tracer, validation) {
				return tracer + " " + validation.message;
			}, "");
			return Object(preact_min["h"])(
				'div',
				{ 'class': 'invalid-feedback' },
				validationMessage
			);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	FormField.prototype.render = function render(_ref, _ref2) {
		var field = _ref.field,
		    responses = _ref.responses;

		_objectDestructuringEmpty(_ref2);

		var sizeClass = cx([{
			field: true,
			Small: field.size === 'Small',
			Medium: field.size === 'Medium',
			Large: field.size === 'Large',
			XLarge: field.size === 'XLarge'
		}, field.customClasses]);
		return Object(preact_min["h"])(
			'div',
			{ 'class': sizeClass },
			Object(preact_min["h"])(
				'label',
				{ 'for': field.mapping },
				field.label
			),
			this.renderField(field, responses),
			this.renderValidationMessages(field, responses)
		);
	};

	return FormField;
}(preact_min["Component"]);


// EXTERNAL MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/src/components/form/submit_button_style.css
var submit_button_style = __webpack_require__("XiFP");
var submit_button_style_default = /*#__PURE__*/__webpack_require__.n(submit_button_style);

// CONCATENATED MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/src/components/form/submit_button.js


function submit_button__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function submit_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function submit_button__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function submit_button__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var submit_button_cx = classnames_default.a.bind(submit_button_style_default.a);

var _ref3 = Object(preact_min["h"])('input', { 'class': 'btn btn-primary', type: 'submit', value: 'Submitting', disabled: 'disabled' });

var submit_button_SubmitButton = function (_Component) {
	submit_button__inherits(SubmitButton, _Component);

	function SubmitButton() {
		submit_button__classCallCheck(this, SubmitButton);

		return submit_button__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SubmitButton.prototype.render = function render(_ref, _ref2) {
		var field = _ref.field,
		    submitting = _ref.submitting;

		submit_button__objectDestructuringEmpty(_ref2);

		var sizeClass = submit_button_cx({
			field: true,
			Small: field.size === 'Small',
			Medium: field.size === 'Medium',
			Large: field.size === 'Large',
			XLarge: field.size === 'XLarge',
			submitButtonContainer: true
		});
		var button = null;
		if (this.props.submitting) {
			button = _ref3;
		} else {
			button = Object(preact_min["h"])('input', { 'class': 'btn btn-primary', type: 'submit', value: field.label });
		}
		return Object(preact_min["h"])(
			'div',
			{ 'class': sizeClass },
			button
		);
	};

	return SubmitButton;
}(preact_min["Component"]);


// CONCATENATED MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/src/components/form/form_row.js


function form_row__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function form_row__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function form_row__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function form_row__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var form_row_FormRow = function (_Component) {
	form_row__inherits(FormRow, _Component);

	function FormRow() {
		form_row__classCallCheck(this, FormRow);

		return form_row__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	FormRow.prototype.render = function render(_ref, _ref2) {
		var _this2 = this;

		var row = _ref.row,
		    responses = _ref.responses,
		    submitting = _ref.submitting,
		    fieldTypeRenderer = _ref.fieldTypeRenderer;

		form_row__objectDestructuringEmpty(_ref2);

		return Object(preact_min["h"])(
			'div',
			{ 'class': 'flexRow' },
			row.fields.map(function (field) {
				if (field.type === "submit") return Object(preact_min["h"])(submit_button_SubmitButton, { field: field, submitting: _this2.props.submitting });
				return Object(preact_min["h"])(form_field_FormField, { field: field, validateAndStoreField: _this2.props.validateAndStoreField, responses: responses, fieldTypeRenderer: fieldTypeRenderer });
			})
		);
	};

	return FormRow;
}(preact_min["Component"]);


// CONCATENATED MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/src/components/form/index.js
var _class, _temp2, _initialiseProps;



function form__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function form__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function form__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function form__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var form_Form = (_temp2 = _class = function (_Component) {
	form__inherits(Form, _Component);

	function Form() {
		var _temp, _this, _ret;

		form__classCallCheck(this, Form);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = form__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), form__possibleConstructorReturn(_this, _ret);
	}

	Form.prototype.render = function render(_ref, _ref2) {
		var _this2 = this;

		var formStructure = _ref.formStructure,
		    fieldTypeRenderer = _ref.fieldTypeRenderer;

		form__objectDestructuringEmpty(_ref2);

		return this.state.submitted ? Object(preact_min["h"])(
			'div',
			null,
			formStructure.info.submissionText
		) : Object(preact_min["h"])(
			'form',
			{ 'class': 'inquiryFormContainer', onSubmit: this.attemptSubmit },
			formStructure.layout.rows.map(function (row) {
				return Object(preact_min["h"])(form_row_FormRow, { row: row, validateAndStoreField: _this2.validateAndStoreField, responses: _this2.state.formResponses, submitting: _this2.state.submitting, fieldTypeRenderer: fieldTypeRenderer });
			})
		);
	};

	return Form;
}(preact_min["Component"]), _initialiseProps = function _initialiseProps() {
	var _this3 = this;

	this.getUrlParameter = function (name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	};

	this.initializeFormResponses = function () {
		var responses = {};
		Object.keys(_this3.props.formStructure.fields).forEach(function (field) {
			responses[field] = { value: _this3.getUrlParameter(field), validationErrors: [] };
		});
		return responses;
	};

	this.state = { formResponses: this.initializeFormResponses(), submitted: false };

	this.runValidations = function (fieldKey, value) {
		var validationErrors = [];
		_this3.props.formStructure.fields[fieldKey].validations.forEach(function (item, index) {
			switch (item.type) {
				case "required":
					if (value === "") {
						validationErrors.push(item);
					}
					break;
				case "dateinfuture":
					var dateValue = Date.parse(value);
					var nowDateTime = new Date();
					var nowDate = new Date(nowDateTime.getFullYear(), nowDateTime.getMonth(), nowDateTime.getDate());
					if (nowDate > dateValue) {
						validationErrors.push(item);
					}
					break;
				case "regex":
					if (value === null || value === "") break;
					var pattern = new RegExp(item.pattern);
					var match = pattern.test(value);
					if (!match) {
						validationErrors.push(item);
					}
					break;
				case "maxLength":
					if (value === null || value === "") break;
					if (value.length > item.maxLength) {
						validationErrors.push(item);
					}
					break;
			}
		});
		return validationErrors;
	};

	this.validateAndStoreField = function (fieldKey, newValue) {
		var validationErrors = _this3.runValidations(fieldKey, newValue);
		var formResponses = _this3.state.formResponses;
		formResponses[fieldKey].value = newValue;
		formResponses[fieldKey].validationErrors = validationErrors;
		_this3.setState({ formResponses: formResponses });
	};

	this.formJSONArgs = function () {
		var args = {};
		// Form identifying info
		args['formKey'] = _this3.props.formStructure.info.formKey;

		// Form response
		Object.keys(_this3.state.formResponses).forEach(function (fieldKey) {
			args[fieldKey] = _this3.state.formResponses[fieldKey].value;
		});

		return args;
	};

	this.attemptSubmit = function (e) {
		e.preventDefault();
		_this3.setState({ submitting: true });
		// check all fields for validations
		var responses = _this3.state.formResponses;
		Object.keys(_this3.props.formStructure.fields).forEach(function (fieldKey) {
			responses[fieldKey].validationErrors = _this3.runValidations(fieldKey, responses[fieldKey].value);
		});
		// if any validation errors are present then stop
		var errorCount = Object.keys(responses).reduce(function (sum, response) {
			return sum + responses[response].validationErrors.length;
		}, 0);
		if (errorCount === 0) {
			// submit that thing
			var body = _this3.formJSONArgs();
			var endpoint = _this3.props.formStructure.info.apiEndpoint;
			var result = fetch('' + endpoint, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'appKey': _this3.props.formStructure.info.appKey,
					'clientKey': _this3.props.formStructure.info.clientKey,
					'formId': _this3.props.formStructure.info.formId
				},
				body: JSON.stringify(body),
				credentials: 'include' }).then(function (response) {
				if (_this3.props.formStructure.info.redirectUrl === '') {
					_this3.setState({ submitted: true });
				} else {
					window.top.location = _this3.props.formStructure.info.redirectUrl;
				}
			});
		} else {
			// there were errors
			console.log("errors so not submitting");
			_this3.setState({ submitting: false });
		}
		_this3.setState({ formResponses: responses });
	};
}, _temp2);

// EXTERNAL MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/rosaliaskitchen/style.css
var rosaliaskitchen_style = __webpack_require__("zdNo");
var rosaliaskitchen_style_default = /*#__PURE__*/__webpack_require__.n(rosaliaskitchen_style);

// CONCATENATED MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/rosaliaskitchen/form_structure.js


var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [{ type: 'required', message: 'Please fill in required field.' }]
    },
    lastName: {
      validations: [{ type: 'required', message: 'Please fill in required field.' }]
    },
    email: {
      validations: [{ type: 'required', message: 'Please provide an email' }, { type: 'required', message: 'Please fill in required field.' }, { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }]
    },
    telNumber: {
      validations: [{ type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }, { type: 'required', message: 'Please fill in required field.' }]
    },
    eventDate: {
      validations: [{ type: 'dateinfuture', message: 'Event date must be in the future' }, { type: 'required', message: 'Please fill in required field.' }]
    },
    StartTime: {
      validations: [{ type: 'required', message: 'Please fill in required field.' }]
    },
    plannedguestcount: {
      validations: [{ type: 'required', message: 'Please fill in required field.' }]
    },
    theme: {
      validations: [{ type: 'required', message: 'Please fill in required field.' }]
    },
    eventextra1: {
      validations: [{ type: 'required', message: 'Please fill in required field.' }]
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [{
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'First Name:*',
        mapping: 'firstName'
      }, {
        type: 'text',
        size: 'Medium',
        label: 'Last Name:*',
        mapping: 'lastName'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'Email Address:*',
        mapping: 'email'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'Phone Number:*',
        mapping: 'telNumber'
      }]
    }, {
      fields: [{
        type: 'date-picker',
        size: 'Medium',
        label: 'Event Date:*',
        mapping: 'eventDate'
      }]
    }, {
      fields: [{
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Event Start Time:*',
        options: [{ label: '7:30 AM', value: '07:30:00' }, { label: '8:00 AM', value: '08:00:00' }, { label: '8:30 AM', value: '08:30:00' }, { label: '9:00 AM', value: '09:00:00' }, { label: '9:30 AM', value: '09:30:00' }, { label: '10:00 AM', value: '10:00:00' }, { label: '10:30 AM', value: '10:30:00' }, { label: '11:00 AM', value: '11:00:00' }, { label: '11:30 AM', value: '11:30:00' }, { label: '12:00 PM', value: '12:00:00' }, { label: '12:30 PM', value: '12:30:00' }, { label: '1:00 PM', value: '13:00:00' }, { label: '1:30 PM', value: '13:30:00' }, { label: '2:00 PM', value: '14:00:00' }, { label: '2:30 PM', value: '14:30:00' }, { label: '3:00 PM', value: '15:00:00' }, { label: '3:30 PM', value: '15:30:00' }, { label: '4:00 PM', value: '16:00:00' }, { label: '4:30 PM', value: '16:30:00' }, { label: '5:00 PM', value: '17:00:00' }, { label: '5:30 PM', value: '17:30:00' }, { label: '6:00 PM', value: '18:00:00' }, { label: '6:30 PM', value: '18:30:00' }, { label: '7:00 PM', value: '19:00:00' }, { label: '7:30 PM', value: '19:30:00' }, { label: '8:00 PM', value: '20:00:00' }, { label: '8:30 PM', value: '20:30:00' }, { label: '9:00 PM', value: '21:00:00' }, { label: '9:30 PM', value: '21:30:00' }, { label: '10:00 PM', value: '22:00:00' }, { label: '10:30 PM', value: '22:30:00' }, { label: '11:00 PM', value: '23:00:00' }, { label: '11:30 PM', value: '23:30:00' }, { label: '12:00 AM (next day)', value: '00:00:00' }, { label: '12:30 AM (next day)', value: '00:30:00' }, { label: '1:00 AM (next day)', value: '01:00:00' }, { label: '1:30 AM (next day)', value: '01:30:00' }, { label: '2:00 AM (next day)', value: '02:00:00' }, { label: '2:30 AM (next day)', value: '02:30:00' }],
        mapping: 'StartTime'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'Number of Guests:*',
        mapping: 'plannedguestcount'
      }]
    }, {
      fields: [{
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Type of Event:*',
        options: [{ label: 'Baby Shower/Gender Reveal', value: 'Baby Shower/Gender Reveal' }, { label: 'Bachelorette/Bachelor Party', value: 'Bachelorette/Bachelor Party' }, { label: 'Birthday Party', value: 'Birthday Party' }, { label: 'Cocktail Reception', value: 'Cocktail Reception' }, { label: 'Corporate Event/Conference', value: 'Corporate Event/Conference' }, { label: 'Family Gathering', value: 'Family Gathering' }, { label: 'Fundraiser', value: 'Fundraiser' }, { label: 'Graduation Party', value: 'Graduation Party' }, { label: 'Special Occasion', value: 'Special Occasion' }, { label: 'Wedding', value: 'Wedding' }],
        mapping: 'theme'
      }]
    }, {
      fields: [{
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Type of service needed:*',
        options: [{ label: 'Delivery Only', value: 'Delivery Only' }, { label: 'Delivery and Setup', value: 'Delivery and Setup' }, { label: 'On-site Service', value: 'On-site Service' }],
        mapping: 'eventextra1'
      }]
    }, {
      fields: [{
        type: 'text',
        size: 'Medium',
        label: 'How did you hear about us?',
        mapping: 'reference'
      }]
    }, {
      fields: [{
        type: 'text-area',
        size: 'Medium',
        label: 'Would you like to add any other details?',
        mapping: 'notes'
      }]
    }, {
      fields: [{
        type: 'submit',
        size: 'XLarge',
        label: 'Submit'
      }]
    }]
  },
  info: {
    title: 'Rosalia\'s Kitchen Contact Form ',
    formId: '691',
    clientKey: 'CEDFC2F1-6BD5-4A9C-9650-E10180999C6B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};

/* harmony default export */ var form_structure = (FormStructure);
// CONCATENATED MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js



/* harmony default export */ var includes = (form_structure);
// EXTERNAL MODULE: ./field_types/text_field_style.css
var text_field_style = __webpack_require__("PkpO");
var text_field_style_default = /*#__PURE__*/__webpack_require__.n(text_field_style);

// CONCATENATED MODULE: ./field_types/text_field.js


function text_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function text_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function text_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function text_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var text_field_TextField = function (_Component) {
  text_field__inherits(TextField, _Component);

  function TextField() {
    var _temp, _this, _ret;

    text_field__classCallCheck(this, TextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = text_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      console.log(_this.props);
      _this.props.updateValue(e.target.value);
    }, _temp), text_field__possibleConstructorReturn(_this, _ret);
  }

  TextField.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        isValid = _ref.isValid,
        response = _ref.response;

    text_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])('input', { id: field.mapping, name: field.mapping, defaultValue: response.value, type: 'text', size: '20', placeholder: field.label, 'class': classes, onBlur: this.updateValue });
  };

  return TextField;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/multiple_choice_field_style.css
var multiple_choice_field_style = __webpack_require__("yeEv");
var multiple_choice_field_style_default = /*#__PURE__*/__webpack_require__.n(multiple_choice_field_style);

// CONCATENATED MODULE: ./field_types/multiple_choice_field.js


function multiple_choice_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function multiple_choice_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function multiple_choice_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function multiple_choice_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var multiple_choice_field__ref3 = Object(preact_min["h"])(
  'option',
  { selected: true },
  'Choose an option'
);

var multiple_choice_field_MultipleChoiceField = function (_Component) {
  multiple_choice_field__inherits(MultipleChoiceField, _Component);

  function MultipleChoiceField() {
    var _temp, _this, _ret;

    multiple_choice_field__classCallCheck(this, MultipleChoiceField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = multiple_choice_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), multiple_choice_field__possibleConstructorReturn(_this, _ret);
  }

  MultipleChoiceField.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        isValid = _ref.isValid,
        responses = _ref.responses;

    multiple_choice_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'custom-select': true,
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])(
      'select',
      { id: field.mapping, name: field.mapping, 'class': classes, onChange: this.updateValue },
      multiple_choice_field__ref3,
      field.options.map(function (option) {
        return Object(preact_min["h"])(
          'option',
          { value: option.value },
          option.label
        );
      })
    );
  };

  return MultipleChoiceField;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./field_types/multiple_choice_field_nolabel.js


function multiple_choice_field_nolabel__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function multiple_choice_field_nolabel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function multiple_choice_field_nolabel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function multiple_choice_field_nolabel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var multiple_choice_field_nolabel_MultipleChoiceFieldNoLabel = function (_Component) {
  multiple_choice_field_nolabel__inherits(MultipleChoiceFieldNoLabel, _Component);

  function MultipleChoiceFieldNoLabel() {
    var _temp, _this, _ret;

    multiple_choice_field_nolabel__classCallCheck(this, MultipleChoiceFieldNoLabel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = multiple_choice_field_nolabel__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), multiple_choice_field_nolabel__possibleConstructorReturn(_this, _ret);
  }

  MultipleChoiceFieldNoLabel.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        isValid = _ref.isValid,
        responses = _ref.responses;

    multiple_choice_field_nolabel__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'custom-select': true,
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])(
      'select',
      { id: field.mapping, name: field.mapping, 'class': classes, onChange: this.updateValue },
      Object(preact_min["h"])(
        'option',
        { selected: true },
        field.label
      ),
      field.options.map(function (option) {
        return Object(preact_min["h"])(
          'option',
          { value: option.value },
          option.label
        );
      })
    );
  };

  return MultipleChoiceFieldNoLabel;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/date_picker_field_style.css
var date_picker_field_style = __webpack_require__("VU9e");
var date_picker_field_style_default = /*#__PURE__*/__webpack_require__.n(date_picker_field_style);

// EXTERNAL MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/node_modules/pikaday/pikaday.js
var pikaday = __webpack_require__("ksyN");
var pikaday_default = /*#__PURE__*/__webpack_require__.n(pikaday);

// EXTERNAL MODULE: C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/node_modules/pikaday/css/pikaday.css
var css_pikaday = __webpack_require__("F+rK");
var css_pikaday_default = /*#__PURE__*/__webpack_require__.n(css_pikaday);

// CONCATENATED MODULE: ./field_types/date_picker_field.js


function date_picker_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function date_picker_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function date_picker_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function date_picker_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var date_picker_field_DatePickerField = function (_Component) {
  date_picker_field__inherits(DatePickerField, _Component);

  function DatePickerField() {
    var _temp, _this, _ret;

    date_picker_field__classCallCheck(this, DatePickerField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = date_picker_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), date_picker_field__possibleConstructorReturn(_this, _ret);
  }

  DatePickerField.prototype.componentDidMount = function componentDidMount() {
    new pikaday_default.a({ field: this.base });
  };

  DatePickerField.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        response = _ref.response,
        isValid = _ref.isValid;

    date_picker_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    var selectedDate = null;

    return Object(preact_min["h"])('input', { id: field.mapping, name: field.mapping, placeholder: field.label, 'class': classes, onBlur: this.updateValue });
  };

  return DatePickerField;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./field_types/date_picker_field_nofill.js


function date_picker_field_nofill__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function date_picker_field_nofill__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function date_picker_field_nofill__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function date_picker_field_nofill__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var date_picker_field_nofill_DatePickerFieldNoFill = function (_Component) {
  date_picker_field_nofill__inherits(DatePickerFieldNoFill, _Component);

  function DatePickerFieldNoFill() {
    var _temp, _this, _ret;

    date_picker_field_nofill__classCallCheck(this, DatePickerFieldNoFill);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = date_picker_field_nofill__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), date_picker_field_nofill__possibleConstructorReturn(_this, _ret);
  }

  DatePickerFieldNoFill.prototype.componentDidMount = function componentDidMount() {
    new pikaday_default.a({ field: this.base });
  };

  DatePickerFieldNoFill.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        response = _ref.response,
        isValid = _ref.isValid;

    date_picker_field_nofill__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    var selectedDate = null;

    return Object(preact_min["h"])('input', { id: field.mapping, name: field.mapping, placeholder: field.label, 'class': classes, onBlur: this.updateValue, autocomplete: 'off' });
  };

  return DatePickerFieldNoFill;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/checkbox_field_style.css
var checkbox_field_style = __webpack_require__("6dB8");
var checkbox_field_style_default = /*#__PURE__*/__webpack_require__.n(checkbox_field_style);

// CONCATENATED MODULE: ./field_types/checkbox_field.js


function checkbox_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function checkbox_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function checkbox_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function checkbox_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var checkbox_field_CheckboxField = function (_Component) {
  checkbox_field__inherits(CheckboxField, _Component);

  function CheckboxField() {
    var _temp, _this, _ret;

    checkbox_field__classCallCheck(this, CheckboxField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = checkbox_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), checkbox_field__possibleConstructorReturn(_this, _ret);
  }

  CheckboxField.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        isValid = _ref.isValid;

    checkbox_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])('input', { name: field.mapping, type: 'checkbox', value: field.label, 'class': classes, onBlur: this.updateValue });
  };

  return CheckboxField;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/text_area_field_style.css
var text_area_field_style = __webpack_require__("bAlB");
var text_area_field_style_default = /*#__PURE__*/__webpack_require__.n(text_area_field_style);

// CONCATENATED MODULE: ./field_types/text_area_field.js


function text_area_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function text_area_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function text_area_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function text_area_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var text_area_field_TextAreaField = function (_Component) {
  text_area_field__inherits(TextAreaField, _Component);

  function TextAreaField() {
    var _temp, _this, _ret;

    text_area_field__classCallCheck(this, TextAreaField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = text_area_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), text_area_field__possibleConstructorReturn(_this, _ret);
  }

  TextAreaField.prototype.render = function render(_ref, _ref2) {
    var field = _ref.field,
        isValid = _ref.isValid;

    text_area_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])('textarea', { id: field.mapping, name: field.mapping, rows: '5', placeholder: field.label, 'class': classes, onBlur: this.updateValue });
  };

  return TextAreaField;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/radio_button_field_style.css
var radio_button_field_style = __webpack_require__("Rrdc");
var radio_button_field_style_default = /*#__PURE__*/__webpack_require__.n(radio_button_field_style);

// CONCATENATED MODULE: ./field_types/radio_button_field.js


function radio_button_field__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function radio_button_field__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function radio_button_field__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function radio_button_field__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var radio_button_field_RadioButtonField = function (_Component) {
  radio_button_field__inherits(RadioButtonField, _Component);

  function RadioButtonField() {
    var _temp, _this, _ret;

    radio_button_field__classCallCheck(this, RadioButtonField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = radio_button_field__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateValue = function (e) {
      _this.props.updateValue(e.target.value);
    }, _temp), radio_button_field__possibleConstructorReturn(_this, _ret);
  }

  RadioButtonField.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var field = _ref.field,
        isValid = _ref.isValid,
        responses = _ref.responses;

    radio_button_field__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])(
      'div',
      null,
      field.options.map(function (option) {
        return Object(preact_min["h"])(
          'div',
          { 'class': 'form-check' },
          Object(preact_min["h"])(
            'label',
            { 'class': 'form-check-label' },
            Object(preact_min["h"])('input', { 'class': 'form-check-input', type: 'radio', name: field.mapping, value: option.value, onChange: _this2.updateValue }),
            option.label
          )
        );
      })
    );
  };

  return RadioButtonField;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./field_types/checkbox_list_style.css
var checkbox_list_style = __webpack_require__("VaZr");
var checkbox_list_style_default = /*#__PURE__*/__webpack_require__.n(checkbox_list_style);

// CONCATENATED MODULE: ./field_types/checkbox_list.js


function checkbox_list__objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function checkbox_list__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function checkbox_list__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function checkbox_list__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var checkbox_list_CheckboxList = function (_Component) {
  checkbox_list__inherits(CheckboxList, _Component);

  function CheckboxList() {
    var _temp, _this, _ret;

    checkbox_list__classCallCheck(this, CheckboxList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = checkbox_list__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.componentDidMount = function () {
      _this.selectedCheckboxes = new Set();
    }, _this.updateValue = function (e) {
      var val = e.target.value;
      if (_this.selectedCheckboxes.has(val)) {
        _this.selectedCheckboxes.delete(val);
      } else {
        _this.selectedCheckboxes.add(val);
      }
      _this.props.updateValue(Array.from(_this.selectedCheckboxes).join());
    }, _temp), checkbox_list__possibleConstructorReturn(_this, _ret);
  }

  CheckboxList.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var field = _ref.field,
        isValid = _ref.isValid;

    checkbox_list__objectDestructuringEmpty(_ref2);

    var classes = classnames_default()({
      'form-control': true,
      'is-invalid': !isValid
    });
    return Object(preact_min["h"])(
      'div',
      null,
      field.options.map(function (option) {
        return Object(preact_min["h"])(
          'div',
          { 'class': 'form-check' },
          Object(preact_min["h"])(
            'label',
            { 'class': 'form-check-label' },
            Object(preact_min["h"])('input', { 'class': 'form-check-input', type: 'checkbox', name: field.mapping, value: option.value, onChange: _this2.updateValue }),
            option.label
          )
        );
      })
    );
  };

  return CheckboxList;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./field_type_renderer.js


function field_type_renderer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }













var field_type_renderer__ref = Object(preact_min["h"])(
	'div',
	null,
	'Unmapped field type'
);

var field_type_renderer_FieldTypeRenderer = function FieldTypeRenderer() {
	field_type_renderer__classCallCheck(this, FieldTypeRenderer);

	this.renderField = function (updateValue, field, responses) {
		console.log([updateValue, field, responses]);
		switch (field.type) {
			case 'label':
				return null;
			case 'text':
				return Object(preact_min["h"])(text_field_TextField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'multiple-choice':
				return Object(preact_min["h"])(multiple_choice_field_MultipleChoiceField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'multiple-choice-nolabel':
				return Object(preact_min["h"])(multiple_choice_field_nolabel_MultipleChoiceFieldNoLabel, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'date-picker':
				return Object(preact_min["h"])(date_picker_field_DatePickerField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'date-picker-nofill':
				return Object(preact_min["h"])(date_picker_field_nofill_DatePickerFieldNoFill, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'checkbox':
				return Object(preact_min["h"])(checkbox_field_CheckboxField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'text-area':
				return Object(preact_min["h"])(text_area_field_TextAreaField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'checkbox-list':
				return Object(preact_min["h"])(checkbox_list_CheckboxList, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
			case 'radio-buttons':
				return Object(preact_min["h"])(radio_button_field_RadioButtonField, { field: field, response: responses[field.mapping], updateValue: updateValue, isValid: responses[field.mapping].validationErrors.length === 0 });
		}
		return field_type_renderer__ref;
	};
};


// EXTERNAL MODULE: ./index.css
var index = __webpack_require__("xHuH");
var index_default = /*#__PURE__*/__webpack_require__.n(index);

// CONCATENATED MODULE: ./index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return index_App; });


function index__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function index__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function index__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var index_App = function (_Component) {
	index__inherits(App, _Component);

	function App() {
		var _temp, _this, _ret;

		index__classCallCheck(this, App);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = index__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { formStructure: includes }, _temp), index__possibleConstructorReturn(_this, _ret);
	}

	App.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			{ id: 'app' },
			Object(preact_min["h"])(form_Form, { formStructure: this.state.formStructure, fieldTypeRenderer: new field_type_renderer_FieldTypeRenderer() })
		);
	};

	return App;
}(preact_min["Component"]);



/***/ }),

/***/ "Lq60":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lt47":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    null != e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "PkpO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rrdc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VU9e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VaZr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XiFP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bAlB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ksyN":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/Pikaday/Pikaday
 */

(function (root, factory) {
    'use strict';

    var moment;
    if (true) {
        // CommonJS module
        // Load moment.js as an optional dependency
        try {
            moment = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"moment\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
        } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req) {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try {
                moment = req(id);
            } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
})(this, function (moment) {
    'use strict';

    /**
     * feature detection and helper functions
     */

    var hasMoment = typeof moment === 'function',
        hasEventListeners = !!window.addEventListener,
        document = window.document,
        sto = window.setTimeout,
        addEvent = function addEvent(el, e, callback, capture) {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },
        removeEvent = function removeEvent(el, e, callback, capture) {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },
        trim = function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    },
        hasClass = function hasClass(el, cn) {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },
        addClass = function addClass(el, cn) {
        if (!hasClass(el, cn)) {
            el.className = el.className === '' ? cn : el.className + ' ' + cn;
        }
    },
        removeClass = function removeClass(el, cn) {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },
        isArray = function isArray(obj) {
        return (/Array/.test(Object.prototype.toString.call(obj))
        );
    },
        isDate = function isDate(obj) {
        return (/Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime())
        );
    },
        isWeekend = function isWeekend(date) {
        var day = date.getDay();
        return day === 0 || day === 6;
    },
        isLeapYear = function isLeapYear(year) {
        // solution lifted from date.js (MIT license): https://github.com/datejs/Datejs
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },
        getDaysInMonth = function getDaysInMonth(year, month) {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },
        setToStartOfDay = function setToStartOfDay(date) {
        if (isDate(date)) date.setHours(0, 0, 0, 0);
    },
        compareDates = function compareDates(a, b) {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },
        extend = function extend(to, from, overwrite) {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                } else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },
        fireEvent = function fireEvent(el, eventName, data) {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },
        adjustCalendar = function adjustCalendar(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month) / 12);
            calendar.month -= 12;
        }
        return calendar;
    },


    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // data-attribute on the input field with an aria assistance tekst (only applied when `bound` is set)
        ariaLabel: 'Use the arrow keys to pick a date',

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the toString function which gets passed a current date object and format
        // and returns a string
        toString: null,

        // used to create date object from current input string
        parse: null,

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // Week picker mode
        pickWholeWeek: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // Allows user to select days that fall in the next or previous month
        enableSelectionDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // Blur field when date is selected
        blurFieldOnSelect: true,

        // internationalization
        i18n: {
            previousMonth: 'Previous Month',
            nextMonth: 'Next Month',
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        },

        // Theme Classname
        theme: null,

        // events array
        events: [],

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null,

        // Enable keyboard input
        keyboardInput: true
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function renderDayName(opts, day, abbr) {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },
        renderDay = function renderDay(opts) {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');

                if (!opts.enableSelectionDaysInNextAndPreviousMonths) {
                    arr.push('is-selection-disabled');
                }
            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.hasEvent) {
            arr.push('has-event');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' + '<button class="pika-button pika-day" type="button" ' + 'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' + opts.day + '</button>' + '</td>';
    },
        isoWeek = function isoWeek(date) {
        // Ensure we're at the start of the day.
        date.setHours(0, 0, 0, 0);

        // Thursday in current week decides the year because January 4th
        // is always in the first week according to ISO8601.

        var yearDay = date.getDate(),
            weekDay = date.getDay(),
            dayInFirstWeek = 4 // January 4th
        ,
            dayShift = dayInFirstWeek - 1 // counting starts at 0
        ,
            daysPerWeek = 7,
            prevWeekDay = function prevWeekDay(day) {
            return (day + daysPerWeek - 1) % daysPerWeek;
        };

        // Adjust to Thursday in week 1 and count number of weeks from date to week 1.

        date.setDate(yearDay + dayShift - prevWeekDay(weekDay));

        var jan4th = new Date(date.getFullYear(), 0, dayInFirstWeek),
            msPerDay = 24 * 60 * 60 * 1000,
            daysBetween = (date.getTime() - jan4th.getTime()) / msPerDay,
            weekNum = 1 + Math.round((daysBetween - dayShift + prevWeekDay(jan4th.getDay())) / daysPerWeek);

        return weekNum;
    },
        renderWeek = function renderWeek(d, m, y) {
        var date = new Date(y, m, d),
            week = hasMoment ? moment(date).isoWeek() : isoWeek(date);

        return '<td class="pika-week">' + week + '</td>';
    },
        renderRow = function renderRow(days, isRTL, pickWholeWeek, isRowSelected) {
        return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },
        renderBody = function renderBody(rows) {
        return '<tbody>' + rows.join('') + '</tbody>';
    },
        renderHead = function renderHead(opts) {
        var i,
            arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },
        renderTitle = function renderTitle(instance, c, year, month, refYear, randId) {
        var i,
            j,
            arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' + (i === month ? ' selected="selected"' : '') + (isMinYear && i < opts.minMonth || isMaxYear && i > opts.maxMonth ? ' disabled="disabled"' : '') + '>' + opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"' : '') + '>' + i + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === instance._o.numberOfMonths - 1) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },
        renderTable = function renderTable(opts, data, randId) {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function Pikaday(options) {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function (e) {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function () {
                            self.hide();
                            if (opts.blurFieldOnSelect && opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                } else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                } else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function (e) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            } else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function (e) {
            e = e || window.event;

            if (self.isVisible()) {

                switch (e.keyCode) {
                    case 13:
                    case 27:
                        if (opts.field) {
                            opts.field.blur();
                        }
                        break;
                    case 37:
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                    case 8:
                    case 46:
                        self.setDate(null);
                        break;
                }
            }
        };

        self._parseFieldValue = function () {
            if (opts.parse) {
                return opts.parse(opts.field.value, opts.format);
            } else if (hasMoment) {
                var date = moment(opts.field.value, opts.format, opts.formatStrict);
                return date && date.isValid() ? date.toDate() : null;
            } else {
                return new Date(Date.parse(opts.field.value));
            }
        };

        self._onInputChange = function (e) {
            var date;

            if (e.firedBy === self) {
                return;
            }
            date = self._parseFieldValue();
            if (isDate(date)) {
                self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function () {
            self.show();
        };

        self._onInputClick = function () {
            self.show();
        };

        self._onInputBlur = function () {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            } while (pEl = pEl.parentNode);

            if (!self._c) {
                self._b = sto(function () {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function (e) {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            } while (pEl = pEl.parentNode);
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);

        if (opts.keyboardInput) {
            addEvent(document, 'keydown', self._onKeyChange);
        }

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                opts.defaultDate = self._parseFieldValue();
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };

    /**
     * public Pikaday API
     */
    Pikaday.prototype = {

        /**
         * configure functionality
         */
        config: function config(options) {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = opts.field && opts.field.nodeName ? opts.field : null;

            opts.theme = typeof opts.theme === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = opts.trigger && opts.trigger.nodeName ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = typeof opts.disableDayFn === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if (opts.minDate && opts.maxDate && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function toString(format) {
            format = format || this._o.format;
            if (!isDate(this._d)) {
                return '';
            }
            if (this._o.toString) {
                return this._o.toString(this._d, format);
            }
            if (hasMoment) {
                return moment(this._d).format(format);
            }
            return this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function getMoment() {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function setMoment(date, preventOnSelect) {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function getDate() {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set the current selection
         */
        setDate: function setDate(date, preventOnSelect) {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * clear and reset the date
         */
        clear: function clear() {
            this.setDate(null);
        },

        /**
         * change view to a specific date
         */
        gotoDate: function gotoDate(date) {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
                lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
                newCalendar = visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate;
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function adjustDate(sign, days) {

            var day = this.getDate() || new Date();
            var difference = parseInt(days) * 24 * 60 * 60 * 1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            this.setDate(newDay);
        },

        adjustCalendars: function adjustCalendars() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function gotoToday() {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function gotoMonth(month) {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function nextMonth() {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function prevMonth() {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function gotoYear(year) {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function setMinDate(value) {
            if (value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function setMaxDate(value) {
            if (value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function setStartRange(value) {
            this._o.startRange = value;
        },

        setEndRange: function setEndRange(value) {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function draw(force) {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            for (var c = 0; c < opts.numberOfMonths; c++) {
                randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if (opts.field.type !== 'hidden') {
                    sto(function () {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }

            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', opts.ariaLabel);
            }
        },

        adjustPosition: function adjustPosition() {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect, leftAligned, bottomAligned;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
            leftAligned = true;
            bottomAligned = true;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top = pEl.offsetTop + pEl.offsetHeight;
                while (pEl = pEl.offsetParent) {
                    left += pEl.offsetLeft;
                    top += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if (this._o.reposition && left + width > viewportWidth || this._o.position.indexOf('right') > -1 && left - width + field.offsetWidth > 0) {
                left = left - width + field.offsetWidth;
                leftAligned = false;
            }
            if (this._o.reposition && top + height > viewportHeight + scrollTop || this._o.position.indexOf('top') > -1 && top - height - field.offsetHeight > 0) {
                top = top - height - field.offsetHeight;
                bottomAligned = false;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';

            addClass(this.el, leftAligned ? 'left-aligned' : 'right-aligned');
            addClass(this.el, bottomAligned ? 'bottom-aligned' : 'top-aligned');
            removeClass(this.el, !leftAligned ? 'left-aligned' : 'right-aligned');
            removeClass(this.el, !bottomAligned ? 'bottom-aligned' : 'top-aligned');
        },

        /**
         * render HTML for a particular month
         */
        render: function render(year, month, randId) {
            var opts = this._o,
                now = new Date(),
                days = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data = [],
                row = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while (after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            var isWeekSelected = false;
            for (var i = 0, r = 0; i < cells; i++) {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
                    isEmpty = i < before || i >= days + before,
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = opts.minDate && day < opts.minDate || opts.maxDate && day > opts.maxDate || opts.disableWeekends && isWeekend(day) || opts.disableDayFn && opts.disableDayFn(day);

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                    day: dayNumber,
                    month: monthNumber,
                    year: yearNumber,
                    hasEvent: hasEvent,
                    isSelected: isSelected,
                    isToday: isToday,
                    isDisabled: isDisabled,
                    isEmpty: isEmpty,
                    isStartRange: isStartRange,
                    isEndRange: isEndRange,
                    isInRange: isInRange,
                    showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                    enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                };

                if (opts.pickWholeWeek && isSelected) {
                    isWeekSelected = true;
                }

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                    row = [];
                    r = 0;
                    isWeekSelected = false;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function isVisible() {
            return this._v;
        },

        show: function show() {
            if (!this.isVisible()) {
                this._v = true;
                this.draw();
                removeClass(this.el, 'is-hidden');
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function hide() {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function destroy() {
            var opts = this._o;

            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            if (opts.keyboardInput) {
                removeEvent(document, 'keydown', this._onKeyChange);
            }
            if (opts.field) {
                removeEvent(opts.field, 'change', this._onInputChange);
                if (opts.bound) {
                    removeEvent(opts.trigger, 'click', this._onInputClick);
                    removeEvent(opts.trigger, 'focus', this._onInputFocus);
                    removeEvent(opts.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;
});

/***/ }),

/***/ "qNvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tzkG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("Lt47");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "xHuH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yeEv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zdNo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.28c0c.js